import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";    
import App from "./App";
import Education from "./componentes/About";

const Navigation = () => {
    return <BrowserRouter>
        <Routes>
            <Route exact path="/" element={<App />}/>
            <Route exact path="/about" element={<Education />} />
        </Routes>
    </BrowserRouter>
}

export default Navigation;